// This file loads the content of the acronyms, glossary, flashcards, articles, and questions.
// (Legacy AES content encryption was removed 2026-07-26 — content now ships as plain JSON.)

import {
    BUNDLE_ACRONYMS,
    BUNDLE_GLOSSARY,
    BUNDLE_FLASHCARDS,
    BUNDLE_QUESTIONS,
    BUNDLE_ARTICLE_COUNTS,
    LOAD_ARTICLES,
  } from "../../content";
  import { GET_APP_DOMAIN_LIST, GET_PRACTICE_TEST } from "../../app_constant";
  import _ from "lodash";

  // Content is stored as plain JS arrays. A value may also be a JSON string
  // (parsed here) or empty; anything else resolves to an empty list.
  const asList = (data, label, bundle) => {
    if (!data || _.isEmpty(data)) {
      console.log(`No valid bundle selected or ${label} available for:`, bundle);
      return [];
    }
    if (Array.isArray(data)) {
      return data;
    }
    if (typeof data === 'string') {
      try {
        return JSON.parse(data);
      } catch (e) {
        console.error(`${label} data corrupted for ${bundle}:`, e);
        return [];
      }
    }
    return [];
  };

  export const GET_ACRONYMS = (SELECTED_BUNDLE) =>
    asList(BUNDLE_ACRONYMS[SELECTED_BUNDLE], 'acronyms', SELECTED_BUNDLE);

  export const GET_GLOSSARY = (SELECTED_BUNDLE) =>
    asList(BUNDLE_GLOSSARY[SELECTED_BUNDLE], 'glossary', SELECTED_BUNDLE);

  export const GET_FLASHCARDS = (SELECTED_BUNDLE) =>
    asList(BUNDLE_FLASHCARDS[SELECTED_BUNDLE], 'flashcards', SELECTED_BUNDLE);

  // Async: article bodies live in a lazily-loaded chunk (see LOAD_ARTICLES). Callers
  // must await this. For counts at startup use BUNDLE_ARTICLE_COUNTS instead.
  export const GET_ARTICLES = async (SELECTED_BUNDLE) =>
    asList(await LOAD_ARTICLES(SELECTED_BUNDLE), 'articles', SELECTED_BUNDLE);

  export const GET_LOCAL_QUESTIONS = (SELECTED_BUNDLE) =>
    asList(BUNDLE_QUESTIONS[SELECTED_BUNDLE], 'questions', SELECTED_BUNDLE);

  export const GET_DOMAIN_NAME = (SELECTED_BUNDLE, topic_id) => {
    const APP_DOMAIN_LIST = GET_APP_DOMAIN_LIST(SELECTED_BUNDLE);
    const array = APP_DOMAIN_LIST.find((e) => e.id == topic_id);
    return array?.domain_name ?? "";
  };

/**
 * Get exam statistics for all available exams
 * @returns {Array} Array of objects containing exam stats with key, title, and counts for questions, flashcards, articles, glossary, and acronyms
 */
export const getExamStats = () => {
  // Import APP_BUNDLES from app_constant
  const { APP_BUNDLES } = require("../../app_constant");

  return APP_BUNDLES.map(bundle => {
    const examKey = bundle.key;
    const examTitle = bundle.title;

    // Get content for this exam using existing functions
    const questions = GET_LOCAL_QUESTIONS(examKey);
    const flashcards = GET_FLASHCARDS(examKey);
    const glossary = GET_GLOSSARY(examKey);
    const acronyms = GET_ACRONYMS(examKey);
    const practiceTests = GET_PRACTICE_TEST(examKey);

    return {
      key: examKey,
      title: examTitle,
      questions: questions ? questions.length : 0,
      flashcards: flashcards ? flashcards.length : 0,
      // Article bodies load lazily; use the static count so stats stay synchronous.
      articles: BUNDLE_ARTICLE_COUNTS[examKey] || 0,
      glossary: glossary ? glossary.length : 0,
      acronyms: acronyms ? acronyms.length : 0,
      practiceTests: practiceTests ? practiceTests.length : 0
    };
  });
};
